export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10097.64f3e31c.jpg";